module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/back-0a9d0b21ea775231f243c67b9b4a66f2.svg";